if (!customElements.get("locales-dialog")) {
    customElements.define(
      "locales-dialog",
      class LocalesDialog extends HTMLElement {
        constructor() {
          super();
          this.init();
        }
  
        init() {
          const dialogOpen = document.getElementById("locale-dialog-open");
          const dialogClose = this.querySelector(".locale-dialog-close");
          if(dialogOpen){
            dialogOpen.onclick = () => {
                this.classList.remove('hide')
              };
          }
        
          dialogClose.onclick = () => {
            this.classList.add('hide');
          };
  
          function isCountryInList(countryList) {
            const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  
            // 判断用户所在时区是否属于指定国家的时区
            return countryList.some((country) => userTimeZone.includes(country));
          }
  
          function testTimeZones() {
            setLocalStorageWithExpiry("_testTimeZonesOpen_", "true", 30);
            const isUSA = isCountryInList([
              "America/New_York",
              "America/Chicago",
              "America/Denver",
              "America/Los_Angeles",
            ]);
            const isUK = isCountryInList(["Europe/London"]);
            const isItaly = isCountryInList(["Europe/Rome"]);
            const isGermany = isCountryInList(["Europe/Berlin"]);
            const isEU = isCountryInList([
              "Europe/Paris",
              "Europe/Berlin",
              "Europe/Rome",
              "Europe/London",
            ]); // 欧盟包含英国、意大利、德国
  
            if (isUK) {
              window.location.href = "https://uk.growattpower.com/";
            } else if (isUSA) {
              window.location.href = "https://growattportable.com/";
            } else if (isEU) {
              window.location.href = "https://eu.growattpower.com/";
            }
          }
  
          function getUrlParams(url) {
            let arr = url.split("?");
            if (arr.length == 1) return {};
            let params = arr[1].split("&");
            let obj = {};
            for (let i = 0; i < params.length; i++) {
              let param = params[i].split("=");
              obj[param[0]] = param[1];
            }
            return obj;
          }
  
          let param = getUrlParams(window.location.href) ?? {};
  
          if (Reflect.has(param, "jumpTypeTimeZones")) {
            sessionStorage.setItem("jumpTypeTimeZones", param.jumpTypeTimeZones);
          }
  
          if (
            !getLocalStorageWithExpiry("_testTimeZonesOpen_") &&
            !Reflect.has(sessionStorage, "jumpTypeTimeZones")
          ) {
            testTimeZones();
          }
  
          function setLocalStorageWithExpiry(key, value, expiryInDays) {
            const now = new Date();
            const expiryTime = now.getTime() + expiryInDays * 24 * 60 * 60 * 1000;
            const item = { value, expiry: expiryTime };
            localStorage.setItem(key, JSON.stringify(item));
          }
  
          // 获取 localStorage 值并检查是否过期
          function getLocalStorageWithExpiry(key) {
            const item = localStorage.getItem(key);
            if (!item) return false;
  
            const now = new Date();
            const parsedItem = JSON.parse(item);
  
            if (now.getTime() > parsedItem.expiry) {
              // 删除过期数据
              localStorage.removeItem(key);
              return false;
            }
  
            return true;
          }
        }
      }
    );
  }
  